import React, { useEffect, useContext, useState } from 'react';
import Layout from 'components/Layout';
import Salutation from 'components/Salutation';
import AccountTabs from 'components/AccountTabs';
import CouponSlider from 'components/CouponSlider';
import SessionFactory from 'factories/Session';
import CartFactory from 'factories/Cart';
import CartService from 'services/Cart/service';
import { main_links, documentTypes } from 'config';
import { CartContext } from '../../cart/CartContext';
import { types } from '../../types/types';
import BgChange from 'assets/images/account/background-change.png';
import { leftPad } from 'config/utils';
import PopupLayout from 'components/PopupLayout';
import PopupLimiteHCanjearLiberar from 'components/PopupLimiteHCanjearLiberar';
import moment from 'moment';

const MyCoupons = () => {

    const { cartDispatch } = useContext(CartContext);
    const [lastCart, setLastCart] = React.useState({});
    const [ timeLeft, setTimeLeft ] = useState('00-00-0000 00:00');
    const [typeCart,setTypeCart]= useState(0);
    const [showLimiteHCanjear, setShowLimiteHCanjear] = useState(false);
    const [cantCupTotalLHCanjear, setCantCupTotalLHCanjear] = useState();
    const [cantCupConsumidosLHCanjear, setCantCupConsumidosLHCanjear] = useState();
    useEffect(() => {
        Promise.all([CartService.getLastCart()]).then(cartLast=>{
            if(cartLast && ['200', '201'].includes(cartLast[0].internalCode)){
                localStorage.setItem("maxLimit", cartLast[0].payload.maxItems);
                cartDispatch({
                    type: types.update,
                    payload: CartFactory.initLastCart(cartLast[0].payload)
                });

                //popup LH
                 const coupons = cartLast[0].payload;
                if (coupons.cantCupConsumidosTotalLH > 0) {
                    valuePopupLimiteCanjear(
                        true,
                        coupons.cantCupConsumidosTotalLH,
                        coupons.cantCupTotalLH
                    );
                }  
                //end popup LH

                 // modify array attribute cuponBonus in cupon personalizado
                 let   cartCoupons = cartLast[0].payload.detalle;
               
                 cartCoupons.map(function(dato){
                     if(dato.personalizado== true ){
                         dato.cuponBonus=false;
                         
                     }
                     return dato
                 }) ;

                // update expiracion with coupon vencimiento
                var daysLH = releaseDay(cartLast[0].payload);
                //update with hour limite horizontal
                var hoursLH = releaseHour(cartLast[0].payload);
 
                //-set variables bonus and personalizado
                 let cuponBonusCart = cartCoupons.map(element=> element.cuponBonus).includes(true);
                 let cuponPersonalizadoCart = cartCoupons.map(element=> element.personalizado).includes(true);
                 cuponBonusCart == false && cuponPersonalizadoCart == false && setTypeCart(0);
                 cuponBonusCart == true && cuponPersonalizadoCart == false && setTypeCart(1);
                 cuponBonusCart == false && cuponPersonalizadoCart == true && setTypeCart(2);
                 cuponBonusCart == true && cuponPersonalizadoCart == true && setTypeCart(3);
 
                  
                
 
                if(cartLast[0].payload?.estado==='L'){
                    timeAnimate(cartLast[0].payload.updateAt,daysLH,hoursLH);
                }
                setLastCart(cartLast[0].payload);
            } else {
                cartDispatch({
                    type: types.update,
                    payload: CartFactory.reset()
                });
            }
        });
    }, []);

    const timeAnimate = (createAt, days,horaFinal) =>{
        createAt=  createAt && createAt!=='' ? (createAt.replace('-','/').replace('-','/')):'';
        const _date = createAt && createAt!=='' ? (new Date(createAt.includes(':')?createAt:(createAt+' 00:00:00'))) : '';
        const endDate = new Date();
        endDate.setTime(_date.getTime() + (days * 24 * 60 * 60 * 1000));
       
        const _day = leftPad(endDate!==''?endDate.getDate():0, 2, '0');
        const _month = leftPad(endDate!==''?(endDate.getMonth()+1):0, 2, '0');
        const _year = endDate!==''?endDate.getFullYear().toString().substr(-2):'00';
        let end = `${_day}.${_month}.${_year} ${horaFinal}`;
       
        
        setTimeLeft(end);
        //setTimeLeft(`${(endDate.getDate()).toString().padStart(2)}-${(endDate.getMonth()+1).toString().padStart(2)}-${endDate.getFullYear()} ${endDate.getHours()}:${endDate.getMinutes()}`);
    }
    const openLimiteHCanjear = (event, forceValue = "none") => {
        event.preventDefault();
        setShowLimiteHCanjear(
            forceValue === "none" ? !showLimiteHCanjear : forceValue
        );
    } 
     const valuePopupLimiteCanjear = (showValue, cupConsumidos, cupTotal) => {
        setShowLimiteHCanjear(showValue);
        setCantCupConsumidosLHCanjear(cupConsumidos);
        setCantCupTotalLHCanjear(cupTotal);
    };
    //return  next day or the present day
 const  releaseDay= (cartLastPayload) => {
    var days;
    if(cartLastPayload.horaLH!==null){
        return days=0;
    
    }else{
        let   cartCoupons = cartLastPayload.detalle;
            
                     // update expiracion with coupon vencimiento 
                     let arrayVencimiento = cartCoupons.map(element=> new Date(element.vencimiento));
                     //minimo update vencimiento
                     var minVencimiento = new Date(Math.min.apply(null,arrayVencimiento));
                     var updateAtCoupon = new Date(cartLastPayload.updateAt);
                     minVencimiento <= updateAtCoupon ? days = 0 : days = 1;
                     return days
    }
    
     }; 
      //return  hour LH or 23:59
      const  releaseHour = (cartLastPayload) => {
        //update with hour limite horizontal
        var horaLH=cartLastPayload.horaLH;
        if(horaLH!=null){
            var fechaUpdate = moment(`${cartLastPayload.updateAt} UTC`).add(horaLH, 'hours');

            return "a las " + fechaUpdate.format("HH:mm");
        }else{
            return 'a las 23:59';
        }
       
        //
         }; 
    
 

    return (
        <div className="mi-cuenta cupones is-logged">
            <Layout>
                <Salutation/>
                <section className="my-account">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-3 mt-4 left-menu">
                                <AccountTabs currentPath={main_links.my_coupons}/>
                            </div>
                            <div className="col-12 col-lg-9 mt-4">
                                <div className="border">
                                {lastCart && lastCart.id && lastCart.estado==='L'
                                    &&
                                    <>
                                    <div className="row">
                                        <div className="col-12 coupon-change">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p className="text-center text-lg-left gray-transparent">Último cupón generado expira el <span className="black">{timeLeft}</span></p>
                                                    <p className="text-center grey-darken-2">{SessionFactory.getItemSession('firstname')} tu código de cupón es:</p>
                                                </div>
                                                <div className="col-3 col-lg-4 pr-0 d-flex align-items-center justify-content-lg-end">
                                                    <p className="image m-0 my-auto">
                                                        <img src={BgChange}/>
                                                    </p>
                                                </div>
                                                <div className="col-9 col-sm-6 col-lg-4 pl-0">
                                                    <p className="text-center mb-3 change-code black">{lastCart.id}</p>
                                                    {lastCart.nroDocumento &&
                                                        <p className="text-center note grey-darken-2">{documentTypes.find(document => document.cod==lastCart.tipoDocumento).title}: {lastCart.nroDocumento ? lastCart.nroDocumento : ''}</p>
                                                    }
                                                </div>
                                                <div className="col-12">
                                                {typeCart === 0  &&
                                                        <p className="text-center note default-red">Muestra este código en caja</p>

                                                    }
                                                    {typeCart === 1  &&
                                                    
                                                        <p className="text-center note default-red">Presentar tu bonus al momento de<br/>canjearlo en caja</p>
                                                    }
                                                    {typeCart === 2  &&
                                                        <div>                                                   
                                                           
                                                            <p className="text-center note default-red">Presentar tu DNI al momento de<br/>canjearlo en caja</p>
                                                        </div>

                                                    }
                                                    {typeCart === 3  &&
                                                        <div>
                                                            
                                                            <p className="text-center note default-red">Presentar tu bonus y tu DNI al momento de<br/>canjearlo en caja</p>
                                                        </div>

                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <p className="text-center txt-14">Este código incluye los siguiente cupónes:</p>
                                        </div>
                                    </div>
                                    <div className="row coupons">
                                        <div className="col-12 mt-4">
                                            <CouponSlider coupons={lastCart.detalle} noslick={true} withoutAction={true} hasSession={true} hasCart={false} changeExpired={true}/>
                                        </div>
                                    </div>
                                    </>
                                }
                                </div>
                            </div>
                            <div className="col-12">
                                <br /><br /><br />
                                <br /><br /><br />
                                <br /><br /><br />
                            </div>
                        </div>
                    </div>
                </section>
                <PopupLayout
                    isShowwing={showLimiteHCanjear}
                    showingCallback={openLimiteHCanjear}
                >
                    <PopupLimiteHCanjearLiberar
                        execActionConfirm={openLimiteHCanjear}
                        cantCupConsumidosLH={cantCupConsumidosLHCanjear}
                        cantCupTotalLH={cantCupTotalLHCanjear}
                    />
                </PopupLayout>
            </Layout>
        </div>
    )
};

export default MyCoupons;